export default __webpack_public_path__ + "static/media/rupee-active.1770a3ff.svg";